<div class="floating-label">
	<ng-container *ngIf="content else input">
		<ng-container *ngTemplateOutlet="content;"></ng-container>
	</ng-container>
	<ng-template #input>
		<app-input-control [isLoadingItems]="isLoadingItems" [defaultSelectedItem]="defaultSelectedItem"
			[selectedItem]="selectedItem" [selectItems]="selectItems" (validForm)="setFormValidity($event)"
			[selectOptionsTemplate]="selectOptionsTemplate" [selectOptionsItems]="selectOptionsItems"
			(valueChanged)="onInputValueChanged($event)" [suffixType]="suffixType" [prefixType]="prefixType"
			[controlDef]="controlDef" [iconPosition]="iconPosition" (inputBlurred)="onBlurred($event)"
			(inputFocused)="onInputFocused($event)" [errorMessage]="errorMessage" [showPlaceholder]="showPlaceHolder"
			[disabledDate]="disabledDate" [disabled]="disabled" [isKuwegoLoanBvn]="isKuwegoLoanBvn"
			[maxBvnLength]="maxBvnLength" [suffixType]="suffixType" (getBvnDetails)="getFloatingBvnDetails($event)"
			(resetBvnDetails)="floatResetBvnDetails($event)" [errorInBvn]="errorInBvn" (openChange)="openChange.emit()">
		</app-input-control>
	</ng-template>
	<ng-container *ngIf="isDisableFocus else normalLabel">
		<label [class]="'label as-label' + ' ' + indentClass" [ngClass]="">
			{{isEmpty ? label : placeHolder}}
		</label>
	</ng-container>

	<ng-template #normalLabel>
		<label *ngIf="controlDef?.type !== 'select'" [class]="labelClass + ' ' + indentClass" [ngClass]="">
			{{isEmpty ? label : placeHolder}}
		</label>
	</ng-template>

</div>